/* Fix megamenu switching: nav links sit above the hover bridge (z-index 10 > 5),
   so mouseenter fires on summaries. Close other open menus on enter. */
(function() {
  var allDetails = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
  var summaries = document.querySelectorAll('.header-nav-row details[data-hover="true"] > summary');
  summaries.forEach(function(summary) {
    summary.addEventListener('mouseenter', function() {
      var parent = summary.closest('details');
      allDetails.forEach(function(other) {
        if (other !== parent && other.hasAttribute('open')) {
          other.removeAttribute('open');
          var s = other.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });
})();

(function() {
  var w = document.querySelector('[data-wnf-search]');
  if (!w) return;
  var inp = w.querySelector('.wnf-search__input');
  var dd = w.querySelector('[data-wnf-dropdown]');
  if (!inp || !dd) return;
  var t, mDown = false;
  var pop = ['Leather Sofa','Rugs','Console Table','Bench','Desk Chair','Bed','Sleeper Sofa','Oregon Made'];

  function e(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function chips() {
    var h = '<div class="wnf-search__section"><span class="wnf-search__section-label">Popular</span><div class="wnf-search__chips">';
    pop.forEach(function(t) { h += '<a href="/search?q=' + encodeURIComponent(t) + '&options%5Bprefix%5D=last" class="wnf-search__chip">' + e(t) + '</a>'; });
    return h + '</div></div>';
  }

  function render(data, q) {
    var r = data.resources ? data.resources.results : {}, p = r.products || [], c = r.collections || [], h = '';
    if (!p.length && !c.length) return '<div class="wnf-search__no-results">No results for \u201c' + e(q) + '\u201d</div>' + chips();
    if (p.length) {
      h += '<div class="wnf-search__section"><span class="wnf-search__section-label">Products</span>';
      p.forEach(function(x) {
        var img = x.image ? x.image + (x.image.indexOf('?') > -1 ? '&' : '?') + 'width=100' : '';
        h += '<a href="' + e(x.url) + '" class="wnf-search__result">';
        if (img) h += '<img src="' + e(img) + '" alt="" class="wnf-search__result-img" loading="lazy">';
        h += '<div class="wnf-search__result-info"><span class="wnf-search__result-title">' + e(x.title) + '</span>';
        if (x.vendor) h += '<span class="wnf-search__result-vendor">' + e(x.vendor) + '</span>';
        h += '</div>';
        var pr = parseFloat(x.price);
        if (!isNaN(pr)) h += '<span class="wnf-search__result-price">$' + pr.toLocaleString(undefined, {minimumFractionDigits: pr % 1 === 0 ? 0 : 2, maximumFractionDigits: 2}) + '</span>';
        h += '</a>';
      });
      h += '</div>';
    }
    if (c.length) {
      h += '<div class="wnf-search__section"><span class="wnf-search__section-label">Collections</span>';
      c.forEach(function(x) { h += '<a href="' + e(x.url) + '" class="wnf-search__result"><div class="wnf-search__result-info"><span class="wnf-search__result-title">' + e(x.title) + '</span></div></a>'; });
      h += '</div>';
    }
    h += '<a href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last" class="wnf-search__view-all">View all results \u2192</a>';
    return h;
  }

  function open() { dd.classList.add('is-open'); }
  function close() { dd.classList.remove('is-open'); }
  function showPop() { dd.innerHTML = chips(); open(); }
  function fetch_(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=4&resources[limit_scope]=each')
      .then(function(r) { return r.json(); })
      .then(function(d) { dd.innerHTML = render(d, q); open(); })
      .catch(function() {});
  }

  inp.addEventListener('focus', function() { inp.value.trim().length ? fetch_(inp.value.trim()) : showPop(); });
  inp.addEventListener('input', function() {
    clearTimeout(t);
    var q = inp.value.trim();
    if (!q.length) { showPop(); return; }
    t = setTimeout(function() { fetch_(q); }, 300);
  });
  dd.addEventListener('mousedown', function() { mDown = true; });
  dd.addEventListener('mouseup', function() { mDown = false; });
  inp.addEventListener('blur', function() { setTimeout(function() { if (!mDown) close(); mDown = false; }, 150); });
  document.addEventListener('click', function(ev) { if (!w.contains(ev.target)) close(); });
  document.addEventListener('keydown', function(ev) {
    if (ev.key === 'Escape' && dd.classList.contains('is-open')) { close(); inp.blur(); }
    if (ev.key === '/' && !ev.ctrlKey && !ev.metaKey && !['INPUT','TEXTAREA','SELECT'].includes(document.activeElement.tagName) && !document.activeElement.isContentEditable) { ev.preventDefault(); inp.focus(); }
  });
})();

/* ── Custom Sort Dropdown (replaces native <select>) ── */
(function() {
  /* Single delegated click handler to close all sort menus (prevents listener leak) */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.wnf-sort')) {
      document.querySelectorAll('.wnf-sort__menu.is-open').forEach(function(m) { m.classList.remove('is-open'); });
      document.querySelectorAll('.wnf-sort__trigger.is-open').forEach(function(t) {
        t.classList.remove('is-open');
        t.setAttribute('aria-expanded', 'false');
      });
    }
  });
  /* Escape closes sort menu */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.wnf-sort__menu.is-open').forEach(function(m) { m.classList.remove('is-open'); });
      document.querySelectorAll('.wnf-sort__trigger.is-open').forEach(function(t) {
        t.classList.remove('is-open');
        t.setAttribute('aria-expanded', 'false');
        t.focus();
      });
    }
  });

  function initSort() {
    var selects = document.querySelectorAll('#SortBy');
    selects.forEach(function(sel) {
      if (sel.dataset.wnfSortDone) return;
      sel.dataset.wnfSortDone = '1';
      var parent = sel.closest('.collection-filter__item--sort');
      if (!parent) return;

      var wrap = document.createElement('div');
      wrap.className = 'wnf-sort';

      /* Build trigger button with ARIA */
      var activeOpt = sel.options[sel.selectedIndex];
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'wnf-sort__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.innerHTML = '<span>' + (activeOpt ? activeOpt.text : 'Sort') + '</span>' +
        '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>';

      /* Build dropdown menu with ARIA */
      var menu = document.createElement('div');
      menu.className = 'wnf-sort__menu';
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', 'Sort options');
      var options = Array.from(sel.options);
      options.forEach(function(opt, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wnf-sort__option' + (opt.selected ? ' is-active' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
        btn.textContent = opt.text;
        btn.dataset.value = opt.value;
        btn.dataset.index = idx;
        btn.addEventListener('click', function() {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.querySelector('span').textContent = opt.text;
          menu.querySelectorAll('.wnf-sort__option').forEach(function(o) {
            o.classList.remove('is-active');
            o.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          menu.classList.remove('is-open');
          trigger.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        });
        menu.appendChild(btn);
      });

      /* Arrow key navigation inside menu */
      menu.addEventListener('keydown', function(ev) {
        var items = menu.querySelectorAll('.wnf-sort__option');
        var cur = Array.from(items).indexOf(document.activeElement);
        if (ev.key === 'ArrowDown') { ev.preventDefault(); items[Math.min(cur + 1, items.length - 1)].focus(); }
        if (ev.key === 'ArrowUp') { ev.preventDefault(); items[Math.max(cur - 1, 0)].focus(); }
        if (ev.key === 'Home') { ev.preventDefault(); items[0].focus(); }
        if (ev.key === 'End') { ev.preventDefault(); items[items.length - 1].focus(); }
      });

      wrap.appendChild(trigger);
      wrap.appendChild(menu);
      parent.appendChild(wrap);

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var wasOpen = menu.classList.contains('is-open');
        /* Close any other open sort menus */
        document.querySelectorAll('.wnf-sort__menu.is-open').forEach(function(m) { m.classList.remove('is-open'); });
        document.querySelectorAll('.wnf-sort__trigger.is-open').forEach(function(t) {
          t.classList.remove('is-open');
          t.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          menu.classList.add('is-open');
          trigger.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          var active = menu.querySelector('.is-active');
          if (active) active.focus();
        }
      });
    });
  }

  /* Init on load and after AJAX content replacement */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSort);
  } else {
    initSort();
  }
  /* Re-init when collection content is replaced via AJAX */
  var sortInitTimer;
  function debouncedInitSort() {
    clearTimeout(sortInitTimer);
    sortInitTimer = setTimeout(initSort, 100);
  }
  document.addEventListener('DOMContentLoaded', function() {
    var ac = document.getElementById('CollectionAjaxContent');
    if (ac) {
      new MutationObserver(debouncedInitSort).observe(ac, { childList: true, subtree: true });
    }
  });
})();

/* ── Keep filter drawer open during AJAX filter updates ── */
(function() {
  function patch() {
    if (typeof theme === 'undefined' || !theme.CollectionSidebar) return;
    var origInit = theme.CollectionSidebar.prototype.init;
    theme.CollectionSidebar.prototype.init = function() {
      var wasOpen = theme.FilterDrawer && theme.FilterDrawer.isOpen;
      origInit.call(this);
      if (wasOpen && theme.FilterDrawer) {
        theme.FilterDrawer.open();
        addFilterFooter();
        autoOpenGroups();
      }
    };
  }
  if (typeof theme !== 'undefined' && theme.CollectionSidebar) {
    patch();
  } else {
    /* theme.js may load after DOMContentLoaded, retry until available */
    var attempts = 0;
    var timer = setInterval(function() {
      attempts++;
      if (typeof theme !== 'undefined' && theme.CollectionSidebar) {
        clearInterval(timer);
        patch();
      } else if (attempts > 50) {
        clearInterval(timer);
      }
    }, 100);
  }
})();

/* ── Filter Drawer: sticky footer + auto-open first groups ── */
function addFilterFooter() {
  var drawer = document.getElementById('FilterDrawer');
  if (!drawer || drawer.querySelector('.wnf-filter-footer')) return;
  var contents = drawer.querySelector('.drawer__contents');
  if (!contents) return;
  var footer = document.createElement('div');
  footer.className = 'wnf-filter-footer';
  footer.innerHTML =
    '<button type="button" class="wnf-filter-footer__clear">Clear All</button>' +
    '<button type="button" class="wnf-filter-footer__show">Show Results</button>';
  contents.appendChild(footer);
  footer.querySelector('.wnf-filter-footer__show').addEventListener('click', function() {
    if (theme.FilterDrawer) theme.FilterDrawer.close();
  });
  footer.querySelector('.wnf-filter-footer__clear').addEventListener('click', function() {
    /* Clear all filters: navigate to the base URL without filter params */
    var url = new URL(window.location.href);
    var keysToRemove = [];
    url.searchParams.forEach(function(val, key) {
      if (key.startsWith('filter.')) keysToRemove.push(key);
    });
    keysToRemove.forEach(function(key) { url.searchParams.delete(key); });
    if (keysToRemove.length > 0) {
      window.location.href = url.toString();
    }
  });
}

function autoOpenGroups() {
  var drawer = document.getElementById('FilterDrawer');
  if (!drawer) return;
  var groups = drawer.querySelectorAll('.collection-sidebar__group');
  /* Open first 4 groups by default per research (Baymard: 4-5 visible) */
  groups.forEach(function(group, i) {
    if (i < 4) {
      var content = group.querySelector('.collapsible-content--sidebar');
      var trigger = group.querySelector('.collapsible-trigger-btn');
      if (content && !content.classList.contains('is-open')) {
        content.classList.add('is-open');
        content.style.height = 'auto';
      }
      if (trigger && !trigger.classList.contains('is-open')) {
        trigger.classList.add('is-open');
      }
    }
  });
}

/* Run on initial page load too */
/* wnf-header-menu-late-dcl-2026-06-21: this asset can be lazy-loaded after DOMContentLoaded, so bind immediately when the DOM is already ready. */
function bindFilterDrawerEnhancements() {
  if (document.documentElement.dataset.wnfFilterDrawerEnhancementsBound) return;
  document.documentElement.dataset.wnfFilterDrawerEnhancementsBound = '1';
  /* Listen for filter drawer open to add footer + auto-open groups */
  document.addEventListener('drawerOpen.FilterDrawer', function() {
    addFilterFooter();
    autoOpenGroups();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindFilterDrawerEnhancements);
} else {
  bindFilterDrawerEnhancements();
}

/* ── Mobile Search Overlay ── */
(function() {
  var overlay = document.querySelector('[data-wnf-mobile-search]');
  if (!overlay) return;
  var inp = overlay.querySelector('.wnf-mobile-search__input');
  var results = overlay.querySelector('[data-wnf-mobile-results]');
  var closeBtn = overlay.querySelector('[data-wnf-mobile-close]');
  var t;
  var pop = ['Leather Sofa','Rugs','Console Table','Bench','Desk Chair','Bed','Sleeper Sofa','Oregon Made'];

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function chips() {
    var h = '<div class="wnf-search__section"><span class="wnf-search__section-label">Popular</span><div class="wnf-search__chips">';
    pop.forEach(function(t) { h += '<button type="button" class="wnf-search__chip" data-chip="' + esc(t) + '">' + esc(t) + '</button>'; });
    return h + '</div></div>';
  }

  function render(data, q) {
    var r = data.resources ? data.resources.results : {}, p = r.products || [], c = r.collections || [], h = '';
    if (!p.length && !c.length) return '<div class="wnf-search__no-results">No results for \u201c' + esc(q) + '\u201d</div>' + chips();
    if (p.length) {
      h += '<div class="wnf-search__section"><span class="wnf-search__section-label">Products</span>';
      p.forEach(function(x) {
        var img = x.image ? x.image + (x.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        h += '<a href="' + esc(x.url) + '" class="wnf-search__result">';
        if (img) h += '<img src="' + esc(img) + '" alt="" class="wnf-search__result-img" loading="lazy">';
        h += '<div class="wnf-search__result-info"><span class="wnf-search__result-title">' + esc(x.title) + '</span>';
        if (x.vendor) h += '<span class="wnf-search__result-vendor">' + esc(x.vendor) + '</span>';
        h += '</div>';
        var pr = parseFloat(x.price);
        if (!isNaN(pr)) h += '<span class="wnf-search__result-price">$' + pr.toLocaleString(undefined, {minimumFractionDigits: pr % 1 === 0 ? 0 : 2, maximumFractionDigits: 2}) + '</span>';
        h += '</a>';
      });
      h += '</div>';
    }
    if (c.length) {
      h += '<div class="wnf-search__section"><span class="wnf-search__section-label">Collections</span>';
      c.forEach(function(x) { h += '<a href="' + esc(x.url) + '" class="wnf-search__result"><div class="wnf-search__result-info"><span class="wnf-search__result-title">' + esc(x.title) + '</span></div></a>'; });
      h += '</div>';
    }
    h += '<a href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last" class="wnf-search__view-all">View all results \u2192</a>';
    return h;
  }

  function showPop() { results.innerHTML = chips(); bindChips(); }
  function doFetch(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=4&resources[limit_scope]=each')
      .then(function(r) { return r.json(); })
      .then(function(d) { results.innerHTML = render(d, q); })
      .catch(function() {});
  }

  function bindChips() {
    results.querySelectorAll('[data-chip]').forEach(function(chip) {
      chip.addEventListener('click', function() {
        inp.value = chip.dataset.chip;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  }

  function openMobile() {
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    showPop();
  }

  function closeMobile() {
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    inp.blur();
    inp.value = '';
    results.innerHTML = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMobile);

  /* Escape key closes mobile overlay */
  document.addEventListener('keydown', function(ev) {
    if (ev.key === 'Escape' && overlay.classList.contains('is-open')) closeMobile();
  });

  inp.addEventListener('input', function() {
    clearTimeout(t);
    var q = inp.value.trim();
    if (!q.length) { showPop(); return; }
    t = setTimeout(function() { doFetch(q); }, 300);
  });

  /* Intercept mobile search icon — prevent iOS zoom by catching touchstart */
  document.querySelectorAll('.js-search-header').forEach(function(btn) {
    btn.addEventListener('touchstart', function(evt) {
      if (window.innerWidth < 769) {
        evt.preventDefault();
        openMobile();
      }
    }, { passive: false, capture: true });
    btn.addEventListener('click', function(evt) {
      if (window.innerWidth < 769) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        openMobile();
      }
    }, true);
  });
})();
